import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import useShopStore from './useShopStore';
import useSettingsStore from './useSettingsStore';

const useAuthStore = create(
  persist(
    (set, get) => ({
      // State
      user: null,
      token: null,
      isAuthenticated: false,
      isLoading: false,

      // Actions
      setCredentials: (user, token) => {
        set({
          user,
          token,
          isAuthenticated: true,
        });
      },

      updateUser: (userData) => {
        set((state) => ({
          user: { ...state.user, ...userData },
        }));
      },

      logout: () => {
        useShopStore.getState().clearShop();
        useSettingsStore.getState().clearSettings();

        // Cerrar el socket es imprescindible: al salir sin recargar la pestaña
        // la conexion seguia viva con el token anterior y el usuario se seguia
        // reportando en linea en el panel del superadmin.
        // Se importa de forma diferida para no crear un ciclo de imports
        // (useNotificationStore ya importa este store).
        import('./useNotificationStore')
          .then((m) => m.default.getState().disconnectSocket())
          .catch(() => {
            // Si el modulo no esta cargado no hay socket que cerrar
          });

        set({
          user: null,
          token: null,
          isAuthenticated: false,
        });
      },

      setLoading: (isLoading) => {
        set({ isLoading });
      },

      // Getters
      getToken: () => get().token,
      getUser: () => get().user,
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);

export default useAuthStore;
